import React from 'react'

import ChevronLeft from '../../public/svgs/chevron_left.svg'
import ChevronRight from '../../public/svgs/chevron_right.svg'

type Prop = {
  getNextWeekLessonData: () => void
  getPreviousWeekLessonData: () => void
  setWeek: (week: number) => void
  week: number
}
export const ChangeWeek = ({
  getNextWeekLessonData,
  getPreviousWeekLessonData,
  setWeek,
  week,
}: Prop) => {
  return (
    <div className="flex justify-between mt-2 mb-2 sp:px-4">
      <button
        className="text-primary border-primary border border-solid text-xs py-2 px-3 pl-3 pr-6 rounded-full font-bold flex items-center disabled:opacity-30"
        type="button"
        disabled={week === 0}
        onClick={() => {
          setWeek(week - 1)
          getPreviousWeekLessonData()
        }}
      >
        <img src={ChevronLeft.src} />
        前の一週間
      </button>
      <button
        className="text-primary border-primary border border-solid text-xs py-2 px-3 pl-6 pr-3 rounded-full font-bold flex items-center disabled:opacity-30"
        type="button"
        disabled={week >= 1}
        onClick={() => {
          setWeek(week + 1)
          getNextWeekLessonData()
        }}
      >
        次の一週間
        <img src={ChevronRight.src} />
      </button>
    </div>
  )
}
